import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography, Divider } from '@material-ui/core';
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { handleSnackBar } from "../../../store/global/actions";
import { invokePostService } from '../../../store/global/actions'

export default function RemoveMember(props) {

    const { memberToRemove, onClose, onCompletion } = props

    const dispatch = useDispatch();
    const memberName = memberToRemove?.userId?.firstName + ' ' + memberToRemove?.userId?.lastName;

    const onDelete = () => {
        dispatch(invokePostService('removeMember', {}, [memberToRemove._id])).then(res => {
            if (res?.status == true) {
                dispatch(handleSnackBar({ open: true, message: `Member removed`, severity: "success" }));
                onCompletion();
            }
        });
    }

    return (
        <>
            <Grid container direction={"row"} spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h6" >Delete</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>

                <Grid xs={12} style={{padding: '10px'}}>

                    <Fragment>
                        <Typography> Are you sure you want to remove {memberName} ? </Typography>
                    </Fragment>

                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <DeleteCancel onCancel={onClose} onDelete={onDelete} />
                </Grid>

            </Grid>

        </>

    )
}
